__turbopack_context__.v({
  "charNice": "p2gjDG_charNice",
  "deletablePosition": "p2gjDG_deletablePosition",
  "position": "p2gjDG_position",
  "removeWordIcon": "p2gjDG_removeWordIcon",
  "wordName": "p2gjDG_wordName",
});
